import icFileDown from "assets/images/ic-file-down-02.svg";
import Button from "components/commons/button";
import DeleteModal from "components/commons/delete-modal";
import FormModal from "components/commons/form-modal";
import Input from "components/commons/input";
import Search from "components/commons/search";
import Select from "components/commons/select";
import Table from "components/commons/table";
import Toast from "components/commons/toast";
import ViewList from "components/commons/view-list";
import { TABLE_EMPLOYEE_PRODUCTIVITY_IMPORT_DATA } from "configs/hr-metrics/configTableEmployeeProductivityList";
import { ImportEmployeeProductivityContainer } from "containers/hr-metrics/employee-productivity/create/ImportEmployeeProductivityContainer";
import { EmployeeProductivityFilterContainer } from "containers/hr-metrics/employee-productivity/EmployeeProductivityFilterContainer";

export const ImportData = ({
    dataList,
    isLoading,
    isDeleting,
    isUpdating,
    isLoadingSubmit,
    query,
    queryFilter,
    toast,
    modal,
    optionsJobTitle,
    form,
    isFormValid,
    onChangeQuery,
    setShowModal,
    clearToast,
    onChangeForm,
    onSearchOptions,
    onHideImport,
    onClickItemHandler,
    onDelete,
    onSubmitEdit,
    onSubmit,
    saveAsDraf,
}) => {

    return (
        <>
            <div className={"flex items-center px-6 py-4 gap-3"}>
                <Search onSearch={(search) => onChangeQuery({page: 1, search})} value={query?.search}/>
                <ViewList
                    show={modal?.limit}
                    onShow={() => setShowModal({limit: true})}
                    onClose={() => setShowModal({limit: false})}
                    value={query?.limit}
                    onSelectSize={(limit) => onChangeQuery({page: 1, limit})}
                />
                <EmployeeProductivityFilterContainer 
                    queryFilter={queryFilter}
                    onSubmit={(queryFilter) => onChangeQuery({...queryFilter, page: 1})} 
                />
                <Button title="Import" icon={icFileDown} type="outline" onClick={() => setShowModal({import: true})}/>
            </div>
            <Table
                className="my-3"
                name={TABLE_EMPLOYEE_PRODUCTIVITY_IMPORT_DATA.name}
                columns={TABLE_EMPLOYEE_PRODUCTIVITY_IMPORT_DATA.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({page: val})}
                onClickSort={(val) => onChangeQuery(val)}
                loading={isLoading}
                onClickItem={(val) => onClickItemHandler(val)}
            />
            <div className={"flex justify-end px-6 py-4 gap-3"}>
                <Button className="px-8" type="outline" title="Save as Draf" onClick={saveAsDraf}/>
                <Button className="px-8" title="Submit" loading={isLoadingSubmit} onClick={onSubmit}/>
            </div>

            <FormModal
                show={modal?.edit}
                onHide={() => setShowModal({edit: false})}
                title={'Edit Employee Productivity'}
                onSubmitForm={onSubmitEdit}
                isLoading={isUpdating}
                isDisabled={!isFormValid}
            >
                <div className={"px-8 py-6 mb-2 space-y-6"}>
                    <div className="flex items-center gap-3">
                        <div className="font-medium w-1/3 text-neutral-70 text-md">{'Nama Karyawan'}</div>
                        <Input
                            className="flex-1"
                            name="employee_name"
                            value={form?.employee_name}
                            disabled
                        />
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="font-medium w-1/3 text-neutral-70 text-md">{'NIP'}</div>
                        <Input
                            className="flex-1"
                            name="employee_nip"
                            value={form?.employee_nip}
                            disabled
                        />
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="font-medium w-1/3 text-neutral-70 text-md">{'Job Title'}</div>
                        <Select
                            name="job_title_id"
                            className='flex-1'
                            placeholder="Pilih job title"
                            options={optionsJobTitle}
                            value={form.job_title_id}
                            onChange={onChangeForm}
                            onSearch={(keyword) => onSearchOptions({ key: 'job_title_id', keyword })}
                        />
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="font-medium w-1/3 text-neutral-70 text-md">{'Department'}</div>
                        <Input
                            className="flex-1"
                            name="department"
                            value={form?.department}
                            disabled
                        />
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="font-medium w-1/3 text-neutral-70 text-md">{'Division'}</div>
                        <Input
                            className="flex-1"
                            name="division"
                            value={form?.division}
                            disabled
                        />
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="font-medium w-1/3 text-neutral-70 text-md">{'KPI Value'}</div>
                        <Input
                            className="flex-1"
                            name="kpi_value"
                            type="number"
                            placeholder="Isi kpi value"
                            value={form?.kpi_value}
                            onChange={onChangeForm}
                        />
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="font-medium w-1/3 text-neutral-70 text-md">{'Salary Value'}</div>
                        <Input
                            className="flex-1"
                            name="salary_value"
                            type="currency"
                            placeholder="Isi salary value"
                            addonBefore={'Rp'}
                            value={form?.salary_value}
                            onChange={onChangeForm}
                        />
                    </div>
                </div>
            </FormModal>

            <DeleteModal
                show={modal?.delete}
                onHide={() => setShowModal({delete: false})}
                onDelete={onDelete}
                isLoading={isDeleting}
                text="Apakah anda yakin ingin menghapus data employee productivity ini ?"
            />

            <Toast
                show={toast?.isShowToast}
                message={toast?.message}
                onClose={() => clearToast()}
            />

            <ImportEmployeeProductivityContainer show={modal?.import} onHide={onHideImport}/>
            
        </>
    )
}
